// Variant keys are intentionally decoupled from the human-readable labels
// so the component can render any incoming status string while still mapping
// to a finite, well-known set of visual treatments.
export const UserStatusBadgeVariants = {
    ACTIVE: 'active',
    INVITED: 'invited',
    INACTIVE: 'inactive',
};

const STATUS_LABEL_MAP = {
    active: UserStatusBadgeVariants.ACTIVE,
    invited: UserStatusBadgeVariants.INVITED,
    inactive: UserStatusBadgeVariants.INACTIVE,
};

export class UserStatusBadgeController {
    getStatusVariant(status) {
        if (!status) return UserStatusBadgeVariants.INACTIVE;
        const normalized = String(status).trim().toLowerCase();
        return STATUS_LABEL_MAP[normalized] || UserStatusBadgeVariants.INACTIVE;
    }

    getStatusDotClassName(status, styles) {
        const variant = this.getStatusVariant(status);

        switch (variant) {
            case UserStatusBadgeVariants.ACTIVE:
                return styles.statusActive;
            case UserStatusBadgeVariants.INVITED:
                return styles.statusInvited;
            case UserStatusBadgeVariants.INACTIVE:
            default:
                return styles.statusInactive;
        }
    }

    getStatusCellClassName(className, styles) {
        if (!className) return styles.statusCell;
        return `${styles.statusCell} ${className}`;
    }

    getStatusLabel(status, fallback = '—') {
        if (!status) return fallback;
        return String(status);
    }
}